import type { ThirdPartyProvidersFeatureConfig } from './type';

export const thirdPartyProviders: ThirdPartyProvidersFeatureConfig = {
    handoverTargetClientId: 'tpp_ssp',
    oidcReady: false,
    target: '',
    passParamsInQuery: false,
    preferTokenExchange: false,
};
